import type { RiskLevel } from '../data/types';

interface Props {
  level: RiskLevel | null;
  score?: number | null;
  showScore?: boolean;
}

const LABELS: Record<RiskLevel, string> = {
  low: 'Минимальный',
  moderate: 'Умеренный',
  elevated: 'Повышенный',
  high: 'Высокий',
};

const TINTS: Record<RiskLevel, { bg: string; fg: string; border: string }> = {
  low:      { bg: '#e6f4e9', fg: '#1f6b34', border: '#9ed4ad' },
  moderate: { bg: '#fff5d9', fg: '#7a5a10', border: '#e6c870' },
  elevated: { bg: '#ffe0c4', fg: '#9b5118', border: '#dfa56b' },
  high:     { bg: '#fde2e2', fg: '#a31919', border: '#e89191' },
};

/**
 * Badge для отображения уровня риска компании. Используется в карточке
 * компании, в списке поиска, в bulk-результатах.
 */
export function RiskBadge({ level, score, showScore = true }: Props) {
  if (!level) {
    return (
      <span className="risk-badge risk-badge--none" aria-label="Риск не рассчитан">
        — нет данных
      </span>
    );
  }
  const tint = TINTS[level];
  return (
    <span
      className={`risk-badge risk-badge--${level}`}
      role="status"
      aria-label={`${LABELS[level]} риск${score !== null && score !== undefined ? `, ${score} из 100` : ''}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        borderRadius: 999,
        fontSize: 13,
        fontWeight: 600,
        background: tint.bg,
        color: tint.fg,
        border: `1px solid ${tint.border}`,
      }}
    >
      <span>{LABELS[level]}</span>
      {showScore && score !== null && score !== undefined && (
        <span style={{ fontFamily: 'JetBrains Mono, monospace', opacity: 0.8 }}>
          {score}
        </span>
      )}
    </span>
  );
}
